/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationCredentialModelDto } from '../../models/integration-credential-model-dto';

export interface IntegrationsControllerGetIntegrations$Params {
}

export function integrationsControllerGetIntegrations(http: HttpClient, rootUrl: string, params?: IntegrationsControllerGetIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IntegrationCredentialModelDto>>> {
  const rb = new RequestBuilder(rootUrl, integrationsControllerGetIntegrations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<IntegrationCredentialModelDto>>;
    })
  );
}

integrationsControllerGetIntegrations.PATH = '/integrations';
